var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33337 10C6.24321 10 6.15549 9.97076 6.08337 9.91667L4.4167 8.66667C4.36495 8.62786 4.32295 8.57753 4.29402 8.51967C4.26509 8.46182 4.25003 8.39802 4.25003 8.33333V5.99167L1.3267 2.70292C1.11908 2.4687 0.983524 2.17951 0.936316 1.8701C0.889108 1.56069 0.932259 1.24423 1.06058 0.958756C1.18891 0.673282 1.39695 0.430941 1.65969 0.260861C1.92244 0.0907803 2.22871 0.000197675 2.5417 0L8.45837 0C8.77133 0.000367105 9.07753 0.0910997 9.34017 0.261294C9.6028 0.431489 9.81071 0.673905 9.9389 0.959411C10.0671 1.24492 10.1101 1.56136 10.0628 1.87073C10.0154 2.18009 9.8798 2.46921 9.67212 2.70333L6.75003 5.99167V9.58333C6.75003 9.69384 6.70613 9.79982 6.62799 9.87796C6.54985 9.9561 6.44387 10 6.33337 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterColumn);
export default __webpack_public_path__ + "static/media/filterColumn.22b1747c5d6729443150c72ed8bffb7a.svg";
export { ForwardRef as ReactComponent };